/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserNotificationEventSource = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserNotificationEventSource model module.
   * @module model/UserNotificationEventSource
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserNotificationEventSource</code>.
   * @alias module:model/UserNotificationEventSource
   * @class
   */
  var exports = function() {
    var _this = this;


















  };

  /**
   * Constructs a <code>UserNotificationEventSource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserNotificationEventSource} obj Optional instance to populate.
   * @return {module:model/UserNotificationEventSource} The populated <code>UserNotificationEventSource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TargetEntityName')) {
        obj['TargetEntityName'] = ApiClient.convertToType(data['TargetEntityName'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('DrillLinkFormat')) {
        obj['DrillLinkFormat'] = ApiClient.convertToType(data['DrillLinkFormat'], 'String');
      }
      if (data.hasOwnProperty('SendToMobile')) {
        obj['SendToMobile'] = ApiClient.convertToType(data['SendToMobile'], 'Boolean');
      }
      if (data.hasOwnProperty('MessageFormat')) {
        obj['MessageFormat'] = ApiClient.convertToType(data['MessageFormat'], 'String');
      }
      if (data.hasOwnProperty('EventImageURI')) {
        obj['EventImageURI'] = ApiClient.convertToType(data['EventImageURI'], 'String');
      }
      if (data.hasOwnProperty('SendToEmail')) {
        obj['SendToEmail'] = ApiClient.convertToType(data['SendToEmail'], 'Boolean');
      }
      if (data.hasOwnProperty('SendToSlack')) {
        obj['SendToSlack'] = ApiClient.convertToType(data['SendToSlack'], 'Boolean');
      }
      if (data.hasOwnProperty('SlackWebhookURL')) {
        obj['SlackWebhookURL'] = ApiClient.convertToType(data['SlackWebhookURL'], 'String');
      }
      if (data.hasOwnProperty('XSLT')) {
        obj['XSLT'] = ApiClient.convertToType(data['XSLT'], 'String');
      }
      if (data.hasOwnProperty('EmailIdentifierFI')) {
        obj['EmailIdentifierFI'] = ApiClient.convertToType(data['EmailIdentifierFI'], 'String');
      }
      if (data.hasOwnProperty('EmailIdentifierEN')) {
        obj['EmailIdentifierEN'] = ApiClient.convertToType(data['EmailIdentifierEN'], 'String');
      }
      if (data.hasOwnProperty('EmailIdentifierSE')) {
        obj['EmailIdentifierSE'] = ApiClient.convertToType(data['EmailIdentifierSE'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Parameter1')) {
        obj['Parameter1'] = ApiClient.convertToType(data['Parameter1'], 'Integer');
      }
      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} TargetEntityName
   * @default ''
   */
  exports.prototype['TargetEntityName'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} DrillLinkFormat
   * @default ''
   */
  exports.prototype['DrillLinkFormat'] = '';
  /**
   * @member {Boolean} SendToMobile
   * @default false
   */
  exports.prototype['SendToMobile'] = false;
  /**
   * @member {String} MessageFormat
   * @default ''
   */
  exports.prototype['MessageFormat'] = '';
  /**
   * @member {String} EventImageURI
   * @default ''
   */
  exports.prototype['EventImageURI'] = '';
  /**
   * @member {Boolean} SendToEmail
   * @default false
   */
  exports.prototype['SendToEmail'] = false;
  /**
   * @member {Boolean} SendToSlack
   * @default false
   */
  exports.prototype['SendToSlack'] = false;
  /**
   * @member {String} SlackWebhookURL
   * @default ''
   */
  exports.prototype['SlackWebhookURL'] = '';
  /**
   * @member {String} XSLT
   * @default ''
   */
  exports.prototype['XSLT'] = '';
  /**
   * @member {String} EmailIdentifierFI
   * @default ''
   */
  exports.prototype['EmailIdentifierFI'] = '';
  /**
   * @member {String} EmailIdentifierEN
   * @default ''
   */
  exports.prototype['EmailIdentifierEN'] = '';
  /**
   * @member {String} EmailIdentifierSE
   * @default ''
   */
  exports.prototype['EmailIdentifierSE'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} Parameter1
   */
  exports.prototype['Parameter1'] = undefined;
  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


